import { useEffect, useRef } from 'react'

export const usePrevious = (prevValue: any) => {
  const ref = useRef(prevValue)
  useEffect(() => {
    ref.current = prevValue
  })
  return ref.current
}
